/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Belief_Title_1Inputs */

const en_about_belief_title_1 = /** @type {(inputs: About_Belief_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useful is something`)
};

const lv_about_belief_title_1 = /** @type {(inputs: About_Belief_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noderīgs ir tas,`)
};

/**
* | output |
* | --- |
* | "Useful is something" |
*
* @param {About_Belief_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_belief_title_1 = /** @type {((inputs?: About_Belief_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Belief_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_belief_title_1(inputs)
	return en_about_belief_title_1(inputs)
});